import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ITeamCatalogItem {
  teamKey: string;
  teamCaption: string;
  sortOrder: number;
}

/**
 * Global squad catalogue (teamKey → teamCaption). Captions are English;
 * UI translation can wrap this later.
 */
@Injectable({
  providedIn: 'root'
})
export class TeamCatalogService {
  private map = new Map<string, string>();
  private loaded = false;

  constructor(private http: HttpClient) {
  }

  public async ensureLoaded(): Promise<void> {
    if (this.loaded) {
      return;
    }
    try {
      const items = await firstValueFrom(
        this.http.get<ITeamCatalogItem[]>(`${environment.authUrl}/Global/Teams`)
      );
      this.map.clear();
      for (const t of items ?? []) {
        this.map.set(t.teamKey, t.teamCaption);
      }
      this.loaded = true;
    } catch {
      // Keep keys as fallback labels.
    }
  }

  public caption(teamKey: string): string {
    return this.map.get(teamKey) || teamKey;
  }
}
